module.exports = __webpack_public_path__ + "static/media/Videotape.308284d2.png";